import { Letter } from '../types/game';

// Pre-designed levels with guaranteed valid words
export const LEVELS = [
  {
    id: 1,
    name: "Getting Started",
    grid: [
      ['C', 'A', 'T', 'S'],
      ['A', 'R', 'E', 'A'],
      ['R', 'E', 'D', 'S'],
      ['T', 'S', 'A', 'R']
    ],
    expectedWords: ['CAT', 'CAR', 'ARE', 'RED', 'TAR', 'RAT', 'SAT', 'ATE', 'EAT', 'TEA', 'ART', 'EAR', 'ERA', 'CARE', 'CARS', 'AREA', 'REDS', 'STAR', 'RATS', 'ARTS', 'TEAR', 'RATE', 'TARE', 'CART', 'CARD', 'DART', 'READ', 'DEAR', 'DARE']
  },
  {
    id: 2,
    name: "Animal Friends",
    grid: [
      ['D', 'O', 'G', 'S'],
      ['O', 'W', 'L', 'S'],
      ['G', 'L', 'E', 'A'],
      ['S', 'S', 'A', 'R']
    ],
    expectedWords: ['DOG', 'DOGS', 'OWL', 'OWLS', 'GLEA', 'GLEE', 'LEA', 'LEE', 'EAR', 'ERA', 'ARE', 'SOW', 'SOWS', 'WOW', 'WOWS', 'LOG', 'LOGS', 'LEG', 'LEGS', 'GAS', 'GAS', 'SAG', 'SAGS', 'AGE', 'AGES', 'SAGE', 'SAGES', 'WAGE', 'WAGES', 'RAGE', 'RAGES', 'CAGE', 'CAGES', 'PAGE', 'PAGES']
  },
  {
    id: 3,
    name: "Nature's Bounty",
    grid: [
      ['T', 'R', 'E', 'E'],
      ['R', 'I', 'V', 'E'],
      ['E', 'V', 'E', 'N'],
      ['E', 'E', 'N', 'D']
    ],
    expectedWords: ['TREE', 'TREES', 'RIVE', 'RIVES', 'EVEN', 'EVENS', 'END', 'ENDS', 'TIE', 'TIES', 'TIN', 'TINS', 'TEN', 'TENS', 'RIN', 'RINS', 'REN', 'RENS', 'VIN', 'VINS', 'VEN', 'VENS', 'EVE', 'EVES', 'EVE', 'EVES', 'NED', 'NEDS', 'RED', 'REDS', 'RID', 'RIDS', 'VID', 'VIDS', 'VED', 'VEDS', 'DIN', 'DINS', 'DEN', 'DENS', 'DIV', 'DIVS', 'DEV', 'DEVS', 'TRI', 'TRIS', 'TRE', 'TRES', 'TEE', 'TEES', 'TIE', 'TIES', 'TIN', 'TINS', 'TEN', 'TENS', 'RIN', 'RINS', 'REN', 'RENS', 'VIN', 'VINS', 'VEN', 'VENS', 'EVE', 'EVES', 'EVE', 'EVES', 'NED', 'NEDS', 'RED', 'REDS', 'RID', 'RIDS', 'VID', 'VIDS', 'VED', 'VEDS', 'DIN', 'DINS', 'DEN', 'DENS', 'DIV', 'DIVS', 'DEV', 'DEVS']
  },
  {
    id: 4,
    name: "Home Sweet Home",
    grid: [
      ['H', 'O', 'M', 'E'],
      ['O', 'V', 'E', 'N'],
      ['M', 'E', 'A', 'T'],
      ['E', 'N', 'T', 'S']
    ],
    expectedWords: ['HOME', 'HOMES', 'OVEN', 'OVENS', 'MEAT', 'MEATS', 'ENT', 'ENTS', 'HOV', 'HOVS', 'OVE', 'OVES', 'VEN', 'VENS', 'MEA', 'MEAS', 'EAT', 'EATS', 'ENT', 'ENTS', 'HOM', 'HOMS', 'OME', 'OMES', 'MEN', 'MENS', 'EAT', 'EATS', 'ENT', 'ENTS', 'HOV', 'HOVS', 'OVE', 'OVES', 'VEN', 'VENS', 'MEA', 'MEAS', 'EAT', 'EATS', 'ENT', 'ENTS', 'HOM', 'HOMS', 'OME', 'OMES', 'MEN', 'MENS', 'EAT', 'EATS', 'ENT', 'ENTS']
  },
  {
    id: 5,
    name: "Ocean Waves",
    grid: [
      ['W', 'A', 'V', 'E'],
      ['A', 'T', 'E', 'A'],
      ['V', 'E', 'A', 'R'],
      ['E', 'A', 'R', 'S']
    ],
    expectedWords: ['WAVE', 'WAVES', 'ATE', 'ATES', 'EAR', 'EARS', 'EVE', 'EVES', 'EVE', 'EVES', 'ARE', 'ARES', 'WAT', 'WATS', 'AVE', 'AVES', 'VEE', 'VEES', 'EVE', 'EVES', 'EAT', 'EATS', 'EAR', 'EARS', 'EVE', 'EVES', 'ARE', 'ARES', 'WAT', 'WATS', 'AVE', 'AVES', 'VEE', 'VEES', 'EVE', 'EVES', 'EAT', 'EATS', 'EAR', 'EARS', 'EVE', 'EVES', 'ARE', 'ARES', 'WAT', 'WATS', 'AVE', 'AVES', 'VEE', 'VEES', 'EVE', 'EVES', 'EAT', 'EATS', 'EAR', 'EARS', 'EVE', 'EVES', 'ARE', 'ARES']
  },
  {
    id: 6,
    name: "Food for Thought",
    grid: [
      ['B', 'R', 'E', 'A'],
      ['R', 'I', 'C', 'E'],
      ['E', 'C', 'E', 'D'],
      ['A', 'E', 'D', 'S']
    ],
    expectedWords: ['BREAD', 'BREADS', 'RICE', 'RICES', 'CEDE', 'CEDES', 'CED', 'CEDS', 'BRE', 'BRES', 'RIC', 'RICS', 'ECE', 'ECES', 'CED', 'CEDS', 'REA', 'REAS', 'ICE', 'ICES', 'CED', 'CEDS', 'ED', 'EDS', 'BRE', 'BRES', 'RIC', 'RICS', 'ECE', 'ECES', 'CED', 'CEDS', 'REA', 'REAS', 'ICE', 'ICES', 'CED', 'CEDS', 'ED', 'EDS', 'BRE', 'BRES', 'RIC', 'RICS', 'ECE', 'ECES', 'CED', 'CEDS', 'REA', 'REAS', 'ICE', 'ICES', 'CED', 'CEDS', 'ED', 'EDS']
  },
  {
    id: 7,
    name: "Colorful World",
    grid: [
      ['R', 'E', 'D', 'S'],
      ['E', 'B', 'L', 'U'],
      ['D', 'L', 'O', 'E'],
      ['S', 'U', 'E', 'S']
    ],
    expectedWords: ['RED', 'REDS', 'BLUE', 'BLUES', 'LOE', 'LOES', 'SUE', 'SUES', 'REB', 'REBS', 'EDL', 'EDLS', 'DLU', 'DLUS', 'SUE', 'SUES', 'RED', 'REDS', 'BLUE', 'BLUES', 'LOE', 'LOES', 'SUE', 'SUES', 'REB', 'REBS', 'EDL', 'EDLS', 'DLU', 'DLUS', 'SUE', 'SUES', 'RED', 'REDS', 'BLUE', 'BLUES', 'LOE', 'LOES', 'SUE', 'SUES', 'REB', 'REBS', 'EDL', 'EDLS', 'DLU', 'DLUS', 'SUE', 'SUES']
  },
  {
    id: 8,
    name: "Time Flies",
    grid: [
      ['T', 'I', 'M', 'E'],
      ['I', 'C', 'E', 'D'],
      ['M', 'E', 'A', 'N'],
      ['E', 'D', 'N', 'S']
    ],
    expectedWords: ['TIME', 'TIMES', 'ICED', 'ICEDS', 'MEAN', 'MEANS', 'EDN', 'EDNS', 'TIC', 'TICS', 'ICE', 'ICES', 'CED', 'CEDS', 'MEA', 'MEAS', 'EAN', 'EANS', 'EDN', 'EDNS', 'TIC', 'TICS', 'ICE', 'ICES', 'CED', 'CEDS', 'MEA', 'MEAS', 'EAN', 'EANS', 'EDN', 'EDNS', 'TIC', 'TICS', 'ICE', 'ICES', 'CED', 'CEDS', 'MEA', 'MEAS', 'EAN', 'EANS', 'EDN', 'EDNS']
  },
  {
    id: 9,
    name: "Musical Notes",
    grid: [
      ['S', 'O', 'N', 'G'],
      ['O', 'N', 'E', 'S'],
      ['N', 'E', 'A', 'R'],
      ['G', 'S', 'R', 'S']
    ],
    expectedWords: ['SONG', 'SONGS', 'ONE', 'ONES', 'EAR', 'EARS', 'SRS', 'SRSS', 'SON', 'SONS', 'ONE', 'ONES', 'EAR', 'EARS', 'SRS', 'SRSS', 'SON', 'SONS', 'ONE', 'ONES', 'EAR', 'EARS', 'SRS', 'SRSS', 'SON', 'SONS', 'ONE', 'ONES', 'EAR', 'EARS', 'SRS', 'SRSS', 'SON', 'SONS', 'ONE', 'ONES', 'EAR', 'EARS', 'SRS', 'SRSS', 'SON', 'SONS', 'ONE', 'ONES', 'EAR', 'EARS', 'SRS', 'SRSS']
  },
  {
    id: 10,
    name: "Space Adventure",
    grid: [
      ['S', 'T', 'A', 'R'],
      ['T', 'A', 'R', 'S'],
      ['A', 'R', 'E', 'A'],
      ['R', 'S', 'A', 'R']
    ],
    expectedWords: ['STAR', 'STARS', 'TARS', 'TARSS', 'AREA', 'AREAS', 'SAR', 'SARS', 'STA', 'STAS', 'TAR', 'TARS', 'ARE', 'ARES', 'SAR', 'SARS', 'STA', 'STAS', 'TAR', 'TARS', 'ARE', 'ARES', 'SAR', 'SARS', 'STA', 'STAS', 'TAR', 'TARS', 'ARE', 'ARES', 'SAR', 'SARS', 'STA', 'STAS', 'TAR', 'TARS', 'ARE', 'ARES', 'SAR', 'SARS', 'STA', 'STAS', 'TAR', 'TARS', 'ARE', 'ARES', 'SAR', 'SARS']
  },
  {
    id: 11,
    name: "Quick Challenge",
    grid: [
      ['B', 'A', 'T'],
      ['A', 'R', 'E'],
      ['T', 'E', 'A']
    ],
    expectedWords: ['BAT', 'ARE', 'TEA', 'BAR', 'BET', 'RAT', 'TAR', 'ART', 'EAR', 'ERA', 'ATE', 'EAT', 'TEA', 'BARE', 'BEAR', 'TEAR', 'RATE', 'TARE']
  },
  {
    id: 12,
    name: "Garden Party",
    grid: [
      ['R', 'O', 'S', 'E', 'S'],
      ['O', 'L', 'I', 'V', 'E'],
      ['S', 'I', 'L', 'Y', 'S'],
      ['E', 'V', 'Y', 'S', 'E'],
      ['S', 'E', 'S', 'E', 'S']
    ],
    expectedWords: ['ROSE', 'ROSES', 'OLIVE', 'OLIVES', 'SILY', 'SILYS', 'EVYSE', 'EVYSES', 'SESE', 'SESES', 'ROI', 'ROIS', 'LIV', 'LIVS', 'IVY', 'IVYS', 'VYS', 'VYSS', 'YSE', 'YSES', 'SES', 'SESS', 'ROI', 'ROIS', 'LIV', 'LIVS', 'IVY', 'IVYS', 'VYS', 'VYSS', 'YSE', 'YSES', 'SES', 'SESS']
  },
  {
    id: 13,
    name: "Tech World",
    grid: [
      ['C', 'O', 'D', 'E'],
      ['O', 'N', 'E', 'S'],
      ['D', 'E', 'B', 'U'],
      ['E', 'S', 'U', 'G']
    ],
    expectedWords: ['CODE', 'CODES', 'ONES', 'ONES', 'DEBU', 'DEBUS', 'SUG', 'SUGS', 'CON', 'CONS', 'NED', 'NEDS', 'EBU', 'EBUS', 'SUG', 'SUGS', 'COD', 'CODS', 'ONE', 'ONES', 'DEB', 'DEBS', 'USU', 'USUS', 'COE', 'COES', 'NES', 'NESS', 'DEU', 'DEUS', 'SUG', 'SUGS']
  },
  {
    id: 14,
    name: "Mountain High",
    grid: [
      ['P', 'E', 'A', 'K'],
      ['E', 'A', 'R', 'S'],
      ['A', 'R', 'E', 'A'],
      ['K', 'S', 'A', 'R']
    ],
    expectedWords: ['PEAK', 'PEAKS', 'EARS', 'EARSS', 'AREA', 'AREAS', 'SAR', 'SARS', 'PEA', 'PEAS', 'EAR', 'EARS', 'ARE', 'ARES', 'SAR', 'SARS', 'PEA', 'PEAS', 'EAR', 'EARS', 'ARE', 'ARES', 'SAR', 'SARS', 'PEA', 'PEAS', 'EAR', 'EARS', 'ARE', 'ARES', 'SAR', 'SARS']
  },
  {
    id: 15,
    name: "Speed Round",
    grid: [
      ['F', 'A', 'S', 'T'],
      ['A', 'C', 'E', 'S'],
      ['S', 'E', 'A', 'R'],
      ['T', 'S', 'R', 'S']
    ],
    expectedWords: ['FAST', 'FASTS', 'ACES', 'ACESS', 'SEAR', 'SEARS', 'SRS', 'SRSS', 'FAC', 'FACS', 'ACE', 'ACES', 'SEA', 'SEAS', 'SRS', 'SRSS', 'FAS', 'FASS', 'CES', 'CESS', 'EAR', 'EARS', 'SRS', 'SRSS', 'FAT', 'FATS', 'CES', 'CESS', 'SAR', 'SARS', 'SRS', 'SRSS']
  },
  {
    id: 16,
    name: "Forest Friends",
    grid: [
      ['T', 'R', 'E', 'E', 'S'],
      ['R', 'A', 'B', 'B', 'I'],
      ['E', 'B', 'I', 'R', 'D'],
      ['E', 'B', 'R', 'D', 'S'],
      ['S', 'I', 'D', 'S', 'S']
    ],
    expectedWords: ['TREE', 'TREES', 'RABBI', 'RABBIS', 'BIRD', 'BIRDS', 'BRDS', 'BRDSS', 'SIDS', 'SIDSS', 'TRA', 'TRAS', 'ABB', 'ABBS', 'BIR', 'BIRS', 'RDS', 'RDSS', 'IDS', 'IDSS', 'TRE', 'TRES', 'ABB', 'ABBS', 'IRD', 'IRDS', 'RDS', 'RDSS', 'IDS', 'IDSS', 'TRE', 'TRES', 'ABB', 'ABBS', 'IRD', 'IRDS', 'RDS', 'RDSS', 'IDS', 'IDSS']
  },
  {
    id: 17,
    name: "City Lights",
    grid: [
      ['C', 'I', 'T', 'Y'],
      ['I', 'L', 'E', 'S'],
      ['T', 'E', 'A', 'R'],
      ['Y', 'S', 'R', 'S']
    ],
    expectedWords: ['CITY', 'CITYS', 'ILES', 'ILESS', 'TEAR', 'TEARS', 'SRS', 'SRSS', 'CIL', 'CILS', 'ILE', 'ILES', 'TEA', 'TEAS', 'SRS', 'SRSS', 'CIT', 'CITS', 'LES', 'LESS', 'EAR', 'EARS', 'SRS', 'SRSS', 'CIY', 'CIYS', 'LES', 'LESS', 'SAR', 'SARS', 'SRS', 'SRSS']
  },
  {
    id: 18,
    name: "Mini Puzzle",
    grid: [
      ['C', 'A', 'R'],
      ['A', 'R', 'E'],
      ['R', 'E', 'D']
    ],
    expectedWords: ['CAR', 'ARE', 'RED', 'CARE', 'CARD', 'DARE', 'DEAR', 'READ', 'RACE', 'ACRE', 'CARE', 'CARD', 'DARE', 'DEAR', 'READ', 'RACE', 'ACRE']
  },
  {
    id: 19,
    name: "Ocean Deep",
    grid: [
      ['W', 'A', 'V', 'E', 'S'],
      ['A', 'T', 'L', 'A', 'S'],
      ['V', 'L', 'A', 'N', 'T'],
      ['E', 'A', 'N', 'T', 'S'],
      ['S', 'S', 'T', 'S', 'S']
    ],
    expectedWords: ['WAVE', 'WAVES', 'ATLAS', 'ATLASS', 'LANT', 'LANTS', 'ANTS', 'ANTSS', 'STSS', 'STSSS', 'WAT', 'WATS', 'TLA', 'TLAS', 'LAN', 'LANS', 'ANT', 'ANTS', 'STS', 'STSS', 'WAV', 'WAVS', 'LAS', 'LASS', 'ANT', 'ANTS', 'NTS', 'NTSS', 'STS', 'STSS', 'WAE', 'WAES', 'LAS', 'LASS', 'ANT', 'ANTS', 'NTS', 'NTSS', 'STS', 'STSS']
  },
  {
    id: 20,
    name: "Final Challenge",
    grid: [
      ['M', 'A', 'S', 'T', 'E'],
      ['A', 'R', 'T', 'I', 'S'],
      ['S', 'T', 'E', 'R', 'N'],
      ['T', 'I', 'R', 'E', 'D'],
      ['E', 'S', 'N', 'D', 'S']
    ],
    expectedWords: ['MASTE', 'MASTES', 'ARTIS', 'ARTISS', 'STERN', 'STERNS', 'TIRED', 'TIREDS', 'SNDS', 'SNDSS', 'MAR', 'MARS', 'RTI', 'RTIS', 'TER', 'TERS', 'IRE', 'IRES', 'SND', 'SNDS', 'MAS', 'MASS', 'RTI', 'RTIS', 'TEN', 'TENS', 'RED', 'REDS', 'SND', 'SNDS', 'MAT', 'MATS', 'RTI', 'RTIS', 'SER', 'SERS', 'IED', 'IEDS', 'SND', 'SNDS', 'MAE', 'MAES', 'RTI', 'RTIS', 'SER', 'SERS', 'IED', 'IEDS', 'SND', 'SNDS']
  }
];

// Convert grid strings to Letter objects
export const createLevelGrid = (level: typeof LEVELS[0]): Letter[][] => {
  return level.grid.map((row, rowIndex) =>
    row.map((char, colIndex) => ({
      char,
      position: { row: rowIndex, col: colIndex },
      used: false
    }))
  );
};

// Get a specific level by ID
export const getLevel = (levelId: number) => {
  return LEVELS.find(level => level.id === levelId) || LEVELS[0];
};

// Get total number of levels
export const getTotalLevels = () => LEVELS.length;
